export default "__VITE_ASSET__D3i$riOo__"